import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../../../components/ui/avatar';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../../components/ui/dropdown-menu';
import { MoreHorizontal, Send, Users, Ban, MessageCircle } from 'lucide-react';
import { colorVars } from './groupColors';

const money = (v) => `$${(Number(v) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Scheda admin secondario: stessa griglia/altezza della scheda utente, colore del gruppo.
export const SecondaryAdminCard = ({
  admin,
  color,
  userCount = 0,
  viewing = false,
  onOpen,
  onToggleUsers,
  onRevoke,
  onLinkTelegram,
}) => {
  const ready = admin.ready_accounts || 0;
  // un admin senza utenti non è un allarme: stato neutro
  const state = userCount === 0 ? 'ok' : ready === 0 ? 'alert' : ready === 1 ? 'warn' : 'ok';
  const neonClass = state === 'ok' ? 'neon n2' : state === 'warn' ? 'neon n4 cy' : 'neon n4 cr';
  const ringColor = state === 'warn' ? 'var(--ht-amber)' : state === 'alert' ? 'var(--ht-red)' : color.c;

  return (
    <div
      onClick={() => onOpen?.(admin)}
      style={state === 'ok' ? { ...colorVars(color), '--ht-ring-c': ringColor } : { '--ht-gc': color.c, '--ht-ring-c': ringColor }}
      className={`ht-panel ht-state-card ${state === 'warn' ? 'ht-state-warn' : state === 'alert' ? 'ht-state-alert' : ''} ${neonClass} relative flex flex-col h-full cursor-pointer`}
      data-testid={`secondary-admin-card-${admin.user_id || admin.id}`}
    >
      <div className="p-3 pl-4 flex flex-col gap-2.5 flex-1">
        <div className="flex items-center gap-2">
          <Avatar className="h-9 w-9 flex-shrink-0 ht-ring">
            {admin.profile_photo ? <AvatarImage src={admin.profile_photo} alt={admin.name} className="object-cover" /> : null}
            <AvatarFallback className="bg-[#1a2026] text-white text-xs font-medium">
              {admin.name?.[0]?.toUpperCase() || 'A'}
            </AvatarFallback>
          </Avatar>
          <h3 className="font-heading font-semibold text-white text-sm leading-snug break-words line-clamp-2 min-w-0 flex-1" title={admin.name}>
            {admin.name}
          </h3>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button onClick={(e) => e.stopPropagation()} className="ht-btn ht-btn-icon flex-shrink-0" title="Altre azioni" data-testid={`admin-card-menu-${admin.user_id || admin.id}`}>
                <MoreHorizontal size={15} />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-[#0d1117] border-[#282c34] min-w-[170px]">
              <DropdownMenuItem className="ht-menu-item ht-menu-item-danger" onClick={(e) => { e.stopPropagation(); onRevoke?.(admin); }} data-testid={`revoke-admin-${admin.user_id || admin.id}`}>
                <Ban size={13} /> Revoca Admin
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>

        <div className="flex items-center gap-1.5 flex-wrap">
          <span className="ht-tag ht-tag-group">Admin Secondario</span>
          {admin.telegram_chat_id ? (
            <Send size={12} className="text-[#5f6672]" title="Telegram collegato" />
          ) : (
            <button
              onClick={(e) => { e.stopPropagation(); onLinkTelegram?.(admin); }}
              className="ht-btn ht-btn-sm"
              data-testid={`link-telegram-secondary-${admin.user_id || admin.id}`}
            >
              <MessageCircle size={11} /> Collega Telegram
            </button>
          )}
        </div>

        <div className="ht-rows">
          <div className="ht-row">
            <span className="ht-row-label">Utenti gestiti</span>
            <span className="ht-row-value">{userCount}</span>
          </div>
          <div className="ht-row">
            <span className="ht-row-label">Conti pronti</span>
            <span className="ht-row-value flex items-center gap-2 justify-end">
              <span className={`ht-dot ${state === 'warn' ? 'ht-dot-warn' : state === 'alert' ? 'ht-dot-alert' : ''}`} />
              <span className={state === 'warn' ? 'ht-warn' : state === 'alert' ? 'ht-alert' : ''}>{ready}</span>
            </span>
          </div>
          <div className="ht-row">
            <span className="ht-row-label">Wallet</span>
            <span className="ht-row-value">{money((admin.wallet_balance_usdt || 0) + (admin.wallet_balance_usdc || 0))}</span>
          </div>
        </div>
      </div>

      <div className="ht-strip">
        <button
          onClick={(e) => { e.stopPropagation(); onToggleUsers?.(admin); }}
          className="ht-btn ht-btn-sm w-full"
          data-testid={`view-admin-users-${admin.user_id || admin.id}`}
        >
          <Users size={12} /> {viewing ? 'Nascondi Utenti' : `Vedi ${userCount} Utenti`}
        </button>
      </div>
    </div>
  );
};

export default SecondaryAdminCard;
